"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.camera_video = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const camera_video = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'camera-video-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14 7.95794V6C14 4.89543 13.1046 4 12 4H3C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H12C13.1046 16 14 15.1046 14 14V12.0421L16.7322 14.5659C17.1699 14.9703 17.8054 15.0772 18.3514 14.8383C18.8973 14.5994 19.25 14.06 19.25 13.4641V6.5359C19.25 5.94 18.8973 5.40062 18.3514 5.16172C17.8054 4.92282 17.1699 5.02972 16.7322 5.43407L14 7.95794ZM3 5.5H12C12.2761 5.5 12.5 5.72386 12.5 6V14C12.5 14.2761 12.2761 14.5 12 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V6C2.5 5.72386 2.72386 5.5 3 5.5ZM14 10L17.75 13.4641V6.5359L14 10Z', fill: '#4B5563' })));
};
exports.camera_video = camera_video;
